import script from "./KsFollowInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./KsFollowInfo.vue?vue&type=script&setup=true&lang=js"

import "./KsFollowInfo.vue?vue&type=style&index=0&id=eaf5544a&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/duanju_admin_vue_live/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-eaf5544a"]])

export default __exports__